'use strict';

angular.module('app.influencerGroupCondition')
	.factory('influencerGroupConditionService', ['$q', '$http', '$rootScope',
        function ($q, $http, $rootScope) {
            var service = {};

            function checkResponse(data) {
              return data;
            }

            function getMessage(data) {
              if (data) {
                return data.message;
              }
              return false;
            }

            function handleRequest(url, method, params, loader) {
                var deferred = $q.defer();

                var req = {
                    url: url,
                    method: method,
                    data: JSON.stringify(params),
                    loader: loader
                } 

                $http(req)
                    .success(function (data) {
                    var dataRes = angular.fromJson(data);

                    if (checkResponse(dataRes)) {
                        deferred.resolve(dataRes);
                    } else {
                        deferred.reject(getMessage(dataRes));
                    }
                })
                    .error(function (error) {
                        deferred.reject(error);
                    });

                return deferred.promise;
            }

            function getInfluencerGroupConditionTypes(loader) {
                var url = $rootScope.apiUrl + 'influencerGroup/getInfluencerGroupConditionTypes';
                return handleRequest(url, 'GET', null, loader);
            }

            function getInfluencerGroupConditionOperators(loader) {
                var url = $rootScope.apiUrl + 'influencerGroup/getInfluencerGroupConditionOperators';
                return handleRequest(url, 'GET', null, loader);
            }

            function getInfluencerGroupComparisions(loader) {
                var url = $rootScope.apiUrl + 'influencerGroup/getInfluencerGroupComparisions';
                return handleRequest(url, 'GET', null, loader);
            }

            function getConditionCountries(loader) {
                var url = $rootScope.apiUrl + 'notification/getConditionCountries';
                return handleRequest(url, 'GET', null, loader);
            }

            service.getInfluencerGroupConditionTypes = getInfluencerGroupConditionTypes;
            service.getInfluencerGroupConditionOperators = getInfluencerGroupConditionOperators;
            service.getInfluencerGroupComparisions = getInfluencerGroupComparisions;
            service.getConditionCountries = getConditionCountries;

            return service;
        }
    ])